/* unplugin-vue-components disabled */import { render } from "./average-table.vue?vue&type=template&id=4227e818&scoped=true"
import script from "./average-table.vue?vue&type=script&lang=js"
export * from "./average-table.vue?vue&type=script&lang=js"

import "./average-table.vue?vue&type=style&index=0&id=4227e818&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4227e818"]])

export default __exports__